export enum Choice {
  YES = 'yes',
  NO = 'no'
}
